import { getServer } from "@translations/next";
import TheHotelContainer from "@containers/TheHotelContainer";
import LocomotiveProvider from "@providers/LocomotiveProvider";
import WrapperProvider from "@providers/WrapperProvider";
import Layout from "@components/Layout";
import StrapiService from "@services/StrapiService";
import FooterService from "@services/FooterService";
import _ from "lodash";

export default function About(props: any) {
  return (
    <WrapperProvider pageContext={props}>
      <Layout>
        <LocomotiveProvider
          options={{
            smooth: true,
            getSpeed: true,
            getDirection: true,
            reloadOnContextChange: true,
            mobile: {
              smooth: true,
            },
            tablet: {
              smooth: true,
            },
          }}
        >
          <TheHotelContainer />
        </LocomotiveProvider>
      </Layout>
    </WrapperProvider>
  );
}

// export { getServerSideProps };
export const getServerSideProps = getServer(async ({ params }: any) => {
  const locale: any = _.get(params, "locale", "en");
  StrapiService.set("id", "hotel65-about-page");
  const res = await StrapiService.find({ populate: "deep", locale });
  StrapiService.set("id", "hotel65-stay-connected");
  const resStay = await StrapiService.find({
    populate: "deep",
    locale,
  });
  const footerData = await FooterService.fetchByHotel("amanaki-boutique-saigon", locale);
  return {
    hotel: "amanaki-boutique-saigon",
    pageData: {
      ..._.get(res, "data", {}),
      stayConnected: _.get(resStay, "data", {}),
    },
    footerData,
  };
});
